const relevantKeys = new Set([
  "A01_Q01", "A12_Q01", "A13_Q01", "A14_Q01", "A14_Q04", "A15_Q05"
]);

function constructStructured(entry) {
  return {
    value:
      entry.measured_value != null
        ? Math.round(entry.measured_value)
        : null,
    time: entry.time
  };
}

function buildLatestMetrics(allMetrics, siteId) {
  const latestMap = {};

  for (const entry of allMetrics) {
    if (entry.site_id !== siteId) continue;
    const key = `${entry.node}_${entry.quant}`;
    if (!relevantKeys.has(key)) continue;

    const existing = latestMap[key];
    if (!existing || new Date(entry.time) > new Date(existing.time)) {
      latestMap[key] = entry;
    }
  }

  const structured = {};
  for (const snapshot of Object.values(latestMap)) {
    if (!structured[snapshot.node]) {
      structured[snapshot.node] = {};
    }
    structured[snapshot.node][snapshot.quant] = constructStructured(snapshot);
  }

  return structured;
}

function buildMinuteSeries(allMetrics, siteId, minutes = 20) {
  const now = Date.now();
  const series = [];

  // Create one-minute windows from (minutes ago → now)
  for (let m = minutes; m >= 1; m--) {
    const windowStart = new Date(now - m * 60 * 1000);
    const windowEnd = new Date(now - (m - 1) * 60 * 1000);

    const slice = allMetrics.filter(e => {
      const t = new Date(e.time);
      return (
        e.site_id === siteId &&
        t >= windowStart &&
        t < windowEnd
      );
    });

    const latest = buildLatestMetrics(slice, siteId);
    series.push(latest);
  }

  return series;
}


export function parseMetrics(allMetrics, siteId) {
  const latestMetrics = buildLatestMetrics(allMetrics, siteId);
  const minuteSnapshots = buildMinuteSeries(allMetrics, siteId, 20);

  const twentyMinuteMetrics = {};

  for (const snapshot of minuteSnapshots) {
    Object.entries(snapshot).forEach(([node, quants]) => {
      Object.entries(quants).forEach(([quant, point]) => {
        twentyMinuteMetrics[node] = twentyMinuteMetrics[node] || {};
        twentyMinuteMetrics[node][quant] = twentyMinuteMetrics[node][quant] || [];
        twentyMinuteMetrics[node][quant].push(point);
      });
    });
  }

  return {
    latestMetrics,
    twentyMinuteMetrics
  };
}